module.exports = __webpack_public_path__ + "static/media/keyman-db-banner-1.85088eb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keyman-db-banner-1.png
// module id = 1282
// module chunks = 1